import { DEFAULT_LANGUAGES, LG } from "@/constants.js";
import { VueCookieNext } from "vue-cookie-next";

import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";

import { useUser } from "@/composables/useUser";

export const metas = {
  data() {
    return {
      alternates: [],
      htmlTitle: "Wegow",
      canonical: "",
      lang: ""
    };
  },
  methods: {
    setSimpleAlternates() {
      for (let language in LG) {
        LG[language].forEach((region, index) => {
          if (index === 0) {
            const linkElement = document.createElement("link");
            linkElement.href = window.location.origin + "/" + region;
            linkElement.rel = "alternate";
            linkElement.hreflang = DEFAULT_LANGUAGES[region];
            document.head.appendChild(linkElement);
          }
          if (
            // region !== actualRegion &&
            !region.includes("-") &&
            DEFAULT_LANGUAGES[region]
          ) {
            const linkElement = document.createElement("link");
            linkElement.href = window.location.origin + "/" + region;
            linkElement.rel = "alternate";
            linkElement.hreflang =
              DEFAULT_LANGUAGES[region] + "-" + region.toUpperCase();
            document.head.appendChild(linkElement);
          }
        });
      }
    },
    setAlternates(
      originalRoute,
      actualRegion,
      alternatesOptions,
      regionsToAdd = []
    ) {
      let index = 0;
      for (let language in LG) {
        let newUrl = alternatesOptions[index].path;
        // Change variables
        newUrl.split("/").forEach((element, index) => {
          if (element.includes(":") && !element.includes(":region")) {
            newUrl = newUrl.replace(element, originalRoute.split("/")[index]);
          }
        });
        let setInitial = false;
        LG[language].forEach((region, i) => {
          if (
            !setInitial &&
            (regionsToAdd.length === 0 || regionsToAdd.includes(region))
          ) {
            setInitial = true;
            let regionUrl = newUrl;
            if (regionUrl.includes(":region")) {
              regionUrl = regionUrl.replace(":region", region);
            }
            const linkElement = document.createElement("link");
            linkElement.href = window.location.origin + regionUrl;
            linkElement.rel = "alternate";
            linkElement.hreflang = DEFAULT_LANGUAGES[region];
            document.head.appendChild(linkElement);
          }
          if (
            // region !== actualRegion &&
            !region.includes("-") &&
            DEFAULT_LANGUAGES[region] &&
            (regionsToAdd.length === 0 || regionsToAdd.includes(region))
          ) {
            let regionUrl = newUrl;
            if (regionUrl.includes(":region")) {
              regionUrl = regionUrl.replace(":region", region);
            }
            const linkElement = document.createElement("link");
            linkElement.href = window.location.origin + regionUrl;
            linkElement.rel = "alternate";
            linkElement.hreflang =
              DEFAULT_LANGUAGES[region] + "-" + region.toUpperCase();
            document.head.appendChild(linkElement);
          }
        });
        index++;
      }
    },
    setHtmlMeta(metaConfig) {
      var fullTitle;
      metaConfig.title = metaConfig.title || "Wegow";
      metaConfig.alternates = metaConfig.alternates || [];
      metaConfig.canonical = metaConfig.canonical || "";
      if (metaConfig.region && !metaConfig.html_personalization_title) {
        var country = constants.REGIONS_NAMES[metaConfig.region];
        fullTitle = metaConfig.title + " " + country;
      } else {
        fullTitle = metaConfig.title;
      }
      var script = [];
      if (metaConfig.home) {
        script.push({
          type: "application/ld+json",
          innerHTML: JSON.stringify(this.structuredData)
        });
      }
      if (typeof metaConfig.event !== "undefined") {
        script.push({
          type: "application/ld+json",
          innerHTML: JSON.stringify(
            this._getEventRichSnippet(metaConfig.event, metaConfig.canonical)
          )
        });
      }
      return {
        title: fullTitle || "",
        link: (() => {
          let hreflangs = [];
          if (metaConfig.alternates && metaConfig.alternates.length > 0) {
            metaConfig.alternates.forEach(alternate => {
              hreflangs.push({
                hid: `alternate-${alternate.region}`,
                rel: "alternate",
                hreflang: alternate.region,
                href: alternate.url
              });
            });
          }
          if (metaConfig.amp) {
            hreflangs.push({
              rel: "amphtml",
              href: metaConfig.canonical + "_amp"
            });
          }
          if (metaConfig.canonical) {
            hreflangs.push({
              hid: "canonical",
              rel: "canonical",
              href: metaConfig.canonical
            });
          }
          return hreflangs;
        })(),
        htmlAttrs: {
          lang: metaConfig.lang || "es"
        },
        meta: (() => {
          let res = [];
          if (metaConfig.description) {
            res.push({
              hid: "description",
              name: "description",
              content: metaConfig.description
            });
            res.push({
              hid: "og:description",
              property: "og:description",
              content: metaConfig.description
            });
          }
          if (metaConfig.index) {
            res.push({
              hid: "robots",
              name: "robots",
              content: "INDEX, FOLLOW"
            });
          } else {
            res.push({
              hid: "robots",
              name: "robots",
              content: "NOINDEX, FOLLOW"
            });
          }
          if (metaConfig.image) {
            res.push({
              hid: "og:image",
              property: "og:image",
              content: metaConfig.image
            });
          }
          if (metaConfig.image) {
            res.push({
              hid: "og:locale",
              property: "og:locale",
              content: metaConfig.lang
            });
          }
          if (metaConfig.title) {
            res.push({
              hid: "og:title",
              property: "og:title",
              content: metaConfig.title
            });
          }
          if (metaConfig.canonical) {
            res.push({
              hid: "og:url",
              property: "og:url",
              content: metaConfig.canonical
            });
          }
          if (metaConfig.facebookDomainVerification) {
            res.push({
              hid: "facebook-domain-verification",
              name: "facebook-domain-verification",
              content: metaConfig.facebookDomainVerification
            });
          }
          return res;
        })(),
        script: script,
        __dangerouslyDisableSanitizers: ["script"]
      };
    },
    _getEventStatus(cancelation_status) {
      if (cancelation_status === 0) {
        return "https://schema.org/EventScheduled";
      } else if (cancelation_status === 1) {
        return "https://schema.org/EventCancelled";
      } else if (cancelation_status === 2) {
        return "https://schema.org/EventPostponed";
      } else if (cancelation_status === 3) {
        return "https://schema.org/EventRescheduled";
      }
      return undefined;
    },
    _getEventRichSnippet(event, canonical) {
      var baseEvent = {
        "@context": "http://schema.org",
        "@type": "MusicEvent",
        name: event.title,
        startDate: this.$moment(event.start_date)
          .utc()
          .format("YYYY-MM-DDTHH:mm:ssZ"),
        endDate: event.end_date
          ? this.$moment(event.end_date)
              .utc()
              .format("YYYY-MM-DDTHH:mm:ssZ")
          : this.$moment(event.start_date)
              .utc()
              .format("YYYY-MM-DDTHH:mm:ssZ"),
        image: event.image_url,
        description: event.description || event.subtitle,
        url: canonical,
        eventStatus: this._getEventStatus(event.cancelation_status),
        eventAttendanceMode:
          event.attendance !== 2
            ? "https://schema.org/OfflineEventAttendanceMode"
            : "https://schema.org/OnlineEventAttendanceMode"
      };
      if (event.venue && event.city) {
        baseEvent.location = {
          "@type": "Place",
          name: event.venue.name,
          address: {
            "@type": "PostalAddress",
            streetAddress: event.venue.address,
            addressLocality: event.city.name,
            addressRegion: event.city.administrative_division,
            addressCountry: event.city?.iso_code
          }
        };
        if (event.links && event.links.length > 0) {
          baseEvent.location.sameAs = [];
          event.links.forEach(item => {
            baseEvent.location.sameAs.push(item.url);
          });
        }
      }
      if (event.ticket_types_count) {
        baseEvent.offers = {
          "@type": "Offer",
          category: "primary",
          url: event.permalink,
          price: event.price,
          priceCurrency: event.currency,
          validFrom: this.$moment(event.created)
            .utc()
            .format("YYYY-MM-DDTHH:mm:ssZ"),
          availability: "http://schema.org/InStock"
        };
      } else {
        baseEvent.offers = {
          "@type": "AggregateOffer",
          lowPrice: event.price,
          priceCurrency: event.currency,
          price: event.price,
          url: event.permalink
        };
      }
      if (event.artists && event.artists.length > 0) {
        baseEvent.performer = [];
        event.artists.forEach(artist => {
          if (artist && artist.name) {
            baseEvent.performer.push({
              "@type": "PerformingGroup",
              name: artist.name
            });
          }
        });
      }
      return baseEvent;
    },

    setIndex(noIndex) {
      const existingMetaTags = document.querySelectorAll(
        'meta[name="robots"][content="noindex"]'
      );
      if (noIndex && existingMetaTags.length === 0) {
        const metaTag = document.createElement("meta");
        metaTag.setAttribute("name", "robots");
        metaTag.setAttribute("content", "noindex");
        document.head.appendChild(metaTag);
      } else if (!noIndex && existingMetaTags.length > 0) {
        existingMetaTags.forEach(metaTag => {
          metaTag.parentNode.removeChild(metaTag);
        });
      }
    },

    setMetasHtml(data, route, router) {
      let structuredData = {
        "@context": "http://schema.org",
        "@type": "Organization",
        url: "https://www.wegow.com",
        logo: "https://cdn.wegow.com/no-delete/wegow/wegow-conciertos.svg",
        address: "Miguel Ángel 13, 3º 28010 Madrid",
        email: "info@wegow.es",
        contactPoint: {
          "@type": "ContactPoint",
          contactType: "customer service"
        }
      };
      // Add/update noIndex
      this.setIndex(data.noIndex);

      // Add/update title
      if (data.title) {
        document.title = data.title;
      }

      // Add/update description
      const existingMeta = document.querySelector('meta[name="description"]');
      if (data.description) {
        if (existingMeta) {
          existingMeta.content = data.description;
        } else {
          const newMeta = document.createElement("meta");
          newMeta.name = "description";
          newMeta.content = data.description;
          document.head.appendChild(newMeta);
        }
      } else if (existingMeta) {
        existingMeta.parentNode.removeChild(existingMeta);
      }

      // delete alternates
      const existingLinks = document.querySelectorAll('link[rel="alternate"]');
      existingLinks.forEach(link => {
        link.parentNode.removeChild(link);
      });

      if (router && route) {
        let routes = router
          .getRoutes()
          .filter(routeObj => routeObj.name === route.name);
        // add alternates
        if (data.alternates) {
          data.alternates.forEach(link => {
            let newUrl = link.url || link;
            const linkElement = document.createElement("link");
            linkElement.href = newUrl;
            linkElement.rel = "alternate";
            const linkRegion = newUrl.split(".com/")[1].slice(0, 2);
            if (linkRegion !== "en") {
              linkElement.hreflang =
                DEFAULT_LANGUAGES[linkRegion] + "-" + linkRegion.toUpperCase();
              document.head.appendChild(linkElement);
            }
          });
        } else if (
          data.alternatesRegions &&
          routes.length >= Object.keys(LG).length
        ) {
          this.setAlternates(
            route.path,
            route.params.region,
            routes,
            data.alternatesRegions
          );
        } else if (routes.length >= Object.keys(LG).length) {
          this.setAlternates(route.path, route.params.region, routes);
        } else if (routes.length === 1) {
          this.setSimpleAlternates();
        }
      }
      let script = document.createElement("script");
      script.type = "application/ld+json";
      script.innerHTML = JSON.stringify(structuredData);
      document.head.appendChild(script);
    },
    setOpenGraph(meta) {
      let metaTitle = document.querySelector("meta[property='og:title']");
      let metaDescription = document.querySelector(
        "meta[property='og:description']"
      );
      let metaImage = document.querySelector("meta[property='og:image']");

      if (metaTitle) {
        metaTitle.parentNode.removeChild(metaTitle);
      }
      if (metaDescription) {
        metaDescription.parentNode.removeChild(metaDescription);
      }
      if (metaImage) {
        metaImage.parentNode.removeChild(metaImage);
      }
      if (meta.title) {
        let metaTagTitle = document.createElement("meta");
        metaTagTitle.setAttribute("property", "og:title");
        metaTagTitle.content = meta.title;
        document.head.appendChild(metaTagTitle);
      }
      if (meta.description) {
        let metaTagDescription = document.createElement("meta");
        metaTagDescription.setAttribute("property", "og:description");
        metaTagDescription.content = meta.description;
        document.head.appendChild(metaTagDescription);
      }

      if (meta.image) {
        let metaTagImage = document.createElement("meta");
        metaTagImage.setAttribute("property", "og:image");
        metaTagImage.content = meta.image;
        document.head.appendChild(metaTagImage);
      }
    },
    setTwitterCard(meta) {
      let metaCard = document.querySelector("meta[name='twitter:card']");
      let metaTitle = document.querySelector("meta[name='twitter:title']");
      let metaDescription = document.querySelector(
        "meta[name='twitter:description']"
      );
      let metaImage = document.querySelector("meta[name='twitter:image']");

      if (metaCard) {
        metaCard.parentNode.removeChild(metaCard);
      }
      if (metaTitle) {
        metaTitle.parentNode.removeChild(metaTitle);
      }
      if (metaDescription) {
        metaDescription.parentNode.removeChild(metaDescription);
      }
      if (metaImage) {
        metaImage.parentNode.removeChild(metaImage);
      }
      if (meta.title || meta.title || meta.image) {
        let metaTagCard = document.createElement("meta");
        metaTagCard.content = "summary_large_image";
        metaTagCard.name = "twitter:card";
      }

      if (meta.title) {
        let metaTagTitle = document.createElement("meta");
        metaTagTitle.content = meta.title;
        metaTagTitle.name = "twitter:title";
        document.head.appendChild(metaTagTitle);
      }

      if (meta.description) {
        let metaTagDescription = document.createElement("meta");
        metaTagDescription.content = meta.description;
        metaTagDescription.name = "twitter:description";
        document.head.appendChild(metaTagDescription);
      }
      if (meta.image) {
        let metaTagImage = document.createElement("meta");
        metaTagImage.name = "twitter:image";
        metaTagImage.content = meta.image;
        document.head.appendChild(metaTagImage);
      }
    },
    setCanonical(route = {}) {
      let pathname = window.location.pathname;
      if (route.path) {
        pathname = route.path;
      }
      var canonicalLink = document.querySelector("link[rel='canonical']");
      if (canonicalLink) {
        canonicalLink.href = window.location.origin + pathname;
      } else {
        var linkTag = document.createElement("link");
        linkTag.setAttribute("rel", "canonical");
        linkTag.setAttribute("href", window.location.origin + pathname);
        document.head.appendChild(linkTag);
      }
    },
    setLanguage() {
      try {
        const $cookie = VueCookieNext;
        const i18n = useI18n();
        const route = useRoute();
        const { userDetail, isAuth } = useUser();
        // // Set language
        if ($cookie.getCookie("wegow.user-language")) {
          i18n.locale.value = $cookie.getCookie("wegow.user-language");
          document.documentElement.lang = $cookie.getCookie(
            "wegow.user-language"
          );
        } else if (isAuth.value && userDetail.value?.language) {
          i18n.locale.value = userDetail.value.language;
          document.documentElement.lang = userDetail.value.language;
          let match_expression =
            process.env.VUE_APP_NUXT_ENV !== "local"
              ? "https://www"
              : "http://www";
          $cookie.setCookie("wegow.user-language", userDetail.value.language, {
            path: "/",
            expire: 60 * 60 * 24 * 365,
            domain: process.env.VUE_APP_NUXT_HOST.replace(match_expression, ""),
            secure: process.env.VUE_APP_NUXT_ENV !== "local"
          });
        } else if (
          route.params?.region &&
          DEFAULT_LANGUAGES[route.params.region]
        ) {
          i18n.locale.value = DEFAULT_LANGUAGES[route.params.region];
          document.documentElement.lang =
            DEFAULT_LANGUAGES[route.params.region];
          let match_expression =
            process.env.VUE_APP_NUXT_ENV !== "local"
              ? "https://www"
              : "http://www";

          $cookie.setCookie(
            "wegow.user-language",
            DEFAULT_LANGUAGES[route.params.region],
            {
              path: "/",
              expire: 60 * 60 * 24 * 365,
              domain: process.env.VUE_APP_NUXT_HOST.replace(
                match_expression,
                ""
              ),
              secure: process.env.VUE_APP_NUXT_ENV !== "local"
            }
          );
        } else {
          i18n.locale.value = "es";
          document.documentElement.lang = "es";
        }
      } catch (e) {
        console.log("Error al setear el idioma");
      }
    }
  }
};
